var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFilters(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "#233E62",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.043 0H1.957C.877.001.001.877 0 1.958v20.086c.002 1.08.877 1.955 1.957 1.956h20.086c1.08-.001 1.955-.876 1.957-1.956V1.958C24 .878 23.124.001 22.043 0zM21.5 22l-19 .041c-.276 0-.5-.224-.5-.5L1.958 2.5c0-.276.224-.5.5-.5L21.5 1.959c.276 0 .5.224.5.5V21.5c0 .276-.224.5-.5.5z",
    transform: "translate(-1126 -117) translate(1126 117)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 17.5h6.646c.442 1.483 1.806 2.5 3.354 2.5s2.912-1.017 3.354-2.5H19.5c.552 0 1-.448 1-1s-.448-1-1-1h-1.646c-.442-1.483-1.806-2.5-3.354-2.5s-2.912 1.017-3.354 2.5H4.5c-.552 0-1 .448-1 1s.448 1 1 1zm10-2.5c.828 0 1.5.672 1.5 1.5s-.672 1.5-1.5 1.5-1.5-.672-1.5-1.5.672-1.5 1.5-1.5zM4.5 8.5h1.146C6.088 9.983 7.452 11 9 11s2.912-1.017 3.354-2.5H19.5c.552 0 1-.448 1-1s-.448-1-1-1h-7.146C11.912 5.017 10.548 4 9 4S6.088 5.017 5.646 6.5H4.5c-.552 0-1 .448-1 1s.448 1 1 1zM9 6c.828 0 1.5.672 1.5 1.5S9.828 9 9 9s-1.5-.672-1.5-1.5S8.172 6 9 6z",
    transform: "translate(-1126 -117) translate(1126 117)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilters);
export default __webpack_public_path__ + "static/media/filters.15913285.svg";
export { ForwardRef as ReactComponent };